(() => {
  if (window.__openMobileContentInit) return;
  window.__openMobileContentInit = true;

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('a.js-open-mobile-content');
    if (!trigger) return;

    e.preventDefault();

    const section = trigger.closest('.shopify-section');
    if (!section) return;

    const innerDiv = section.querySelector(':scope > div');
    if (!innerDiv) return;

    innerDiv.classList.add('active-mobile');
  });
})();